export const feedSchedulerSelectionStateBlackList = [
  "#contacts@group.v.calendar.google.com",
  "tasks@tasks.google.com",
  "reminders@reminders.google.com",
  /^(\S+)@group\.v\.(\S+)\.google\.com$/gi, // this is a regex for google group domains that we want to avoid (i.e. holiday cal)
  /^(\S+)@resource\.calendar\.google\.com$/gi, // this is a regex for google resource domains that we want to avoid
  /^(\S+)@group\.calendar\.google\.com$/gi, // this is a regex for google group domains that we want to avoid (i.e. our pto calendar)
  /^(\S+)@import\.calendar\.google\.com$/gi, // this is a regex for google group domains that we want to avoid
];

export function isEmailBlackListedForFeedScheduler(
  email: string,
  blacklist: (string | RegExp | undefined)[],
) {
  return blacklist.some((blacklistKey) => {
    if (typeof blacklistKey === "string") {
      return blacklistKey === email;
    } else if (!!blacklistKey) {
      const matches = email.match(blacklistKey);
      return !!matches && matches.length > 0;
    }
    return false;
  });
}
